import {Container, Paper, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from "react-router-dom";

const VerificationMailSendPage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const clickRegister = () => {
        navigate("/register")
    }

    return (
        <Container sx={{padding: '12px'}}>
            <Paper
                elevation={4}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    maxWidth: '900px',
                    margin: 'auto',
                    padding: '12px',
                }}
            >
                <Typography variant="h5" sx={{marginBottom: '12px'}}>
                    {t('VERIFICATION_EMAIL_SENT_TEXT')}
                </Typography>
                <Typography variant="body1" sx={{marginBottom: '12px'}}>
                    {t('CHECK_EMAIL_INSTRUCTIONS_TEXT')}
                </Typography>
                <Typography
                    onClick={clickRegister}
                    sx={{textAlign: 'left', width: '95%', cursor: 'pointer'}} variant="body1"
                >
                    {t("BACK_TO_LOGIN_TEXT")}
                </Typography>
            </Paper>
        </Container>
    );
};

export default VerificationMailSendPage;
